// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Qech","options":"AnswerScale_options__ni4yI","selected":"AnswerScale_selected__QP6uH"};